import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SITE } from "@/constants/testIds";
import { ReportCard } from "@/components/site/ReportCard";

// Hoisted so framer-motion gets a stable object reference across re-renders.
const CARD_VIEWPORT = { once: true, margin: "-80px" };

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, delay: i * 0.06, ease: "easeOut" },
  }),
};

/** One per-section strip on the homepage (e.g. Indian Market, Unlisted...). */
export function HomeSectionStrip({ section, reports }) {
  return (
    <div data-testid={`${SITE.sectionHomeStrip}-${section.key}`} className="border-t border-kira-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-14">
        <div className="flex items-end justify-between gap-4 mb-6">
          <div className="flex items-center gap-3 min-w-0">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-kira-gold/10 border border-kira-gold/30">
              <section.icon className="h-4 w-4 text-kira-gold" />
            </div>
            <div className="min-w-0">
              <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-kira-textMuted mb-0.5">Coverage</p>
              <h2 className="font-chivo text-lg font-bold text-white truncate">{section.label}</h2>
            </div>
          </div>
          <Link
            to={`/research/${section.key}`}
            className="hidden sm:inline-flex items-center gap-1.5 text-xs font-mono text-kira-textMuted hover:text-kira-gold transition-colors whitespace-nowrap"
          >
            View all <ArrowRight className="h-3 w-3" />
          </Link>
        </div>
        {reports.length === 0 ? (
          <div className="rounded-lg border border-dashed border-kira-border py-12 text-center">
            <p className="text-sm text-kira-textMuted">
              Research for this section is being prepared. Check back soon.
            </p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {reports.map((r, i) => (
              <motion.div key={r.id} variants={fadeUp} initial="hidden" whileInView="show" viewport={CARD_VIEWPORT} custom={i}>
                <ReportCard report={r} />
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
